// Error codes from getAccessTokenSilently that mean the session is dead and
// only an interactive login can recover it. auth0-spa-js v2 with
// useRefreshTokens and no fallback throws missing_refresh_token when the
// refresh token is gone from cache (e.g. another tab logged out) and
// invalid_grant when it is revoked/rotated out — not just login_required.
// invalid_grant from a multi-tab rotation race costs unsaved in-memory
// state, but a dead grant has no softer recovery than an interactive login.
export const REAUTH_ERRORS = new Set<string>([
  "login_required",
  "interaction_required",
  "missing_refresh_token",
  "invalid_grant",
]);

// Bridges the Auth0 React hook to non-axios callers (fetch streams) that the
// request interceptor in <Auth> can't cover. <Auth> wires the getter on mount.
type TokenGetter = () => Promise<string | null>;

let getToken: TokenGetter | null = null;

export const setAccessTokenGetter = (fn: TokenGetter) => {
  getToken = fn;
};

export const getFreshAccessToken = async (): Promise<string | null> =>
  getToken ? getToken() : null;
